<style lang="scss" src='@/views/login/Login.scss' scoped ></style>
<style lang="scss" src='./RecoveryEmailSent.scss' scoped ></style>
<template src="./RecoveryEmailSent.html"></template>

<script>
export default {
  name: 'RecoveryEmailSent',
};
</script>
